import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../core/auth/auth.service';
import { AlertService } from '../../../shared/services/alert.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  loginForm: FormGroup;
  showPassword = false;
  private alertService = inject(AlertService);
  private auth = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private fb = inject(FormBuilder);

  constructor() {
    this.loginForm = this.fb.group({
      phoneNumber: ['', [
        Validators.required,
        Validators.pattern(/^(\+994 \((50|51|10|70|77|55|99)\) \d{3}-\d{2}-\d{2}|\+994 (50|51|10|70|77|55) \d{3} \d{2} \d{2})$/)
      ]],
      password: ['', [Validators.required, Validators.minLength(8)]]
    });
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      let phone = this.loginForm.get('phoneNumber')?.value as string;
      const password = this.loginForm.get('password')?.value as string;

      // Format: +994XXXXXXXXX
      phone = phone.replace(/\s+/g, '').replace(/[()\-]/g, '');

      this.auth.login(phone, password).subscribe({
        next: () => {
          this.alertService.success('Giriş uğurludur');
          const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
          this.router.navigateByUrl(returnUrl);
        },
        error: (err) => {
          const errorObj = err.error?.error || err.error;
          const errorCode = errorObj?.code || 'UNKNOWN_ERROR';
          const errorDetails = errorObj?.details;
          this.alertService.errorByCode(errorCode, errorDetails);
        }
      });
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  onPhoneInput(event: any): void {
    const input = event.target;
    let value = input.value;
    const selectionStart = input.selectionStart;
    const oldLength = value.length;

    // Yalnız rəqəmləri saxlayırıq
    let digits = value.replace(/\D/g, '');

    // Əgər +994 ilə başlayırsa, onu çıxarırıq (formatlamada yenidən əlavə olunacaq)
    if (digits.startsWith('994')) {
      digits = digits.substring(3);
    }

    // Maksimum 9 rəqəm (operator + nömrə)
    digits = digits.substring(0, 9);

    let formattedValue = '+994 ';
    if (digits.length > 0) {
      formattedValue += '(' + digits.substring(0, 2);
      if (digits.length > 2) {
        formattedValue += ') ' + digits.substring(2, 5);
        if (digits.length > 5) {
          formattedValue += '-' + digits.substring(5, 7);
          if (digits.length > 7) {
            formattedValue += '-' + digits.substring(7, 9);
          }
        }
      }
    }

    this.loginForm.get('phoneNumber')?.setValue(formattedValue, { emitEvent: false });

    // Kursorun mövqeyini hesablamaq və bərpa etmək
    setTimeout(() => {
      const newLength = formattedValue.length;
      let newSelection = selectionStart + (newLength - oldLength);

      // Kursorun yanlış yerdə qalmaması üçün tənzimləmə
      input.setSelectionRange(newSelection, newSelection);
    }, 0);
  }
}
